var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDaysWaiting(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Days Waiting") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.46875,0 C16.0402344,0 16.5,0.461914062 16.5,1.03125 C16.5,1.60058594 16.0402344,2.0625 15.46875,2.0625 L15.125,2.0625 L15.125,2.87804688 C15.125,4.61054687 14.3988281,6.23476562 13.2128906,7.49804688 L9.70664063,11 L13.2128906,14.5019531 C14.3988281,15.7265625 15.125,17.3894531 15.125,19.1210938 L15.125,19.9375 L15.46875,19.9375 C16.0402344,19.9375 16.5,20.3972656 16.5,20.96875 C16.5,21.5402344 16.0402344,22 15.46875,22 L1.03125,22 C0.461914062,22 0,21.5402344 0,20.96875 C0,20.3972656 0.461914062,19.9375 1.03125,19.9375 L1.375,19.9375 L1.375,19.1210938 C1.375,17.3894531 2.06292969,15.7265625 3.28796875,14.5019531 L6.79335937,11 L3.28796875,7.49804688 C2.06292969,6.23476562 1.375,4.61054687 1.375,2.87804688 L1.375,2.0625 L1.03125,2.0625 C0.461914062,2.0625 0,1.60058594 0,1.03125 C0,0.461914062 0.461914062,0 1.03125,0 L15.46875,0 Z M8.25,12.4566406 L4.74804688,15.9628906 C3.9084375,16.7621094 3.4375,17.9351562 3.4375,19.1210938 L3.4375,19.9375 L13.0625,19.9375 L13.0625,19.1210938 C13.0625,17.9351562 12.5898438,16.7621094 11.7519531,15.9628906 L8.25,12.4566406 Z M8.25,9.54335937 L11.7519531,6.03710937 C12.5898438,5.19921875 13.0625,4.063125 13.0625,2.87804688 L13.0625,2.02382813 L3.4375,2.02382813 L3.4375,2.87804688 C3.4375,4.063125 3.9084375,5.19921875 4.74804688,6.03710937 L8.25,9.54335937 Z",
    id: "daysWaiting"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons/outline/days_waiting_24px",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(4.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-daysWaiting",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#daysWaiting"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask-DW",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#daysWaiting"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u21B3-Color",
    mask: "url(#mask-daysWaiting)",
    fill: "#34436D"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4.000000, -1.000000)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 125,
    height: 50
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDaysWaiting);
export default __webpack_public_path__ + "static/media/DaysWaiting.8898e3fa.svg";
export { ForwardRef as ReactComponent };